module.exports = __webpack_public_path__ + "static/ilutracao-gestao-categoria-862ac64a1187e341dafadeb292c3b154.svg";